module.exports = __webpack_public_path__ + "img/1933917.0bdd1d02.svg";